import { Text } from '@fluentui/react-components';
import { AddCircleRegular } from '@fluentui/react-icons';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { fileUploadValidator } from '../../../shared/functions';
import { questionnaireLogoFileConfiguration } from '../../../configurations';
import { UploadedMedia } from '../../../models';
import { FlexBox } from '../../shared-components/flex-box';
import { UploadButton } from '../../shared-components';
import DocumentFile from '../../shared-components/DocumentFile';
import './UploadLogoSection.scss';

interface UploadLogoSectionProps {
  logo: UploadedMedia;
  onUploadLogo(mediaContent: File): void;
  onDeleteLogo(uploadedMediaId: number): void;
}

const UploadLogoSectionImpl: React.FC<UploadLogoSectionProps> = (props) => {
  const {
    logo,
    onUploadLogo,
    onDeleteLogo,
  } = props;
  const [uploadErrorMessages, setUploadErrorMessages] = useState<string[]>([]);

  const handleSelectedFile = (files: FileList | null) => {
    setUploadErrorMessages([]);
    if (!files || !files[0] || files.length > 1) return;

    const file = files[0];
    const validationResult = fileUploadValidator(file, questionnaireLogoFileConfiguration);
    if (!validationResult.isValid) {
      setUploadErrorMessages(validationResult.errorMessages);
      return;
    }

    logo.originalFileName = file.name;
    onUploadLogo(file);
  };

  return (
    <>
      <FlexBox
        isFullWidth
        direction='column'
        aligns='start'
        className='upload-logo-section'
      >
        <Text weight='semibold' size={400} block>Help Us Celebrate You!</Text>
        <Text block>Select winners might be featured during the award-winner recognition segment of Ignite.</Text>
        <Text weight='semibold' size={400} block>We need your company logo!</Text>
        <Text block>Please upload your company logo for possible inclusion as part of the digital event.</Text>
        <Text weight='semibold' block>Format:</Text>
        <ul>
          <li>Transparent PNG file</li>
          <li>As high resolution as possible, at least 800x800 pixels</li>
        </ul>
        <UploadButton
          onUpload={handleSelectedFile}
          acceptFiles={questionnaireLogoFileConfiguration.supportedFileExtensions.join(',')}
          validationMessage={uploadErrorMessages.join('\n')}
          infoLabel='(File types accepted: png)'
          buttonProps={{
            appearance: 'primary',
            children: 'Upload Logo',
            icon: (<AddCircleRegular />),
            disabled: logo?.uploadedMediaId > 0,
          }}
        >
          {
            logo && logo.uploadedMediaId > 0 &&
            <DocumentFile
              filename={logo.originalFileName}
              onDeleteFile={() => onDeleteLogo(logo.uploadedMediaId)}
            />
          }
        </UploadButton>
      </FlexBox>
    </>
  );
}

export const UploadLogoSection = observer(UploadLogoSectionImpl);
